export interface ComplianceAndPercentageDTO {
  compliant          : number;
  compliantPercent   : number;
  notCompliant       : number;
  notCompliantPercent: number;
};

export function ComplianceAndPercentageDTO_EmptyObject(): ComplianceAndPercentageDTO {
  return {
    compliant          : 0,
    compliantPercent   : 0,
    notCompliant       : 0,
    notCompliantPercent: 0,
  }
};
